import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1V15M1 8H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgPlus);
const Memo = memo(ForwardRef);
export default Memo;
